function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var r = function r(_r) {
  return String(_r).split(".").map(function (r) {
    return String(parseInt(r || "0", 10));
  }).concat(["0", "0"]).slice(0, 3).join(".");
};
var e = /*#__PURE__*/function () {
  function e() {
    _classCallCheck(this, e);
    this.isSwupPlugin = !0, this.swup = void 0, this.version = void 0, this.requires = {}, this.handlersToUnregister = [];
  }
  _createClass(e, [{
    key: "mount",
    value: function mount() {}
  }, {
    key: "unmount",
    value: function unmount() {
      this.handlersToUnregister.forEach(function (r) {
        return r();
      }), this.handlersToUnregister = [];
    }
  }, {
    key: "_beforeMount",
    value: function _beforeMount() {
      if (!this.name) throw new Error("You must define a name of plugin when creating a class.");
    }
  }, {
    key: "_afterUnmount",
    value: function _afterUnmount() {}
  }, {
    key: "_checkRequirements",
    value: function _checkRequirements() {
      var _this = this;
      return "object" != _typeof(this.requires) || Object.entries(this.requires).forEach(function (_e) {
        var _e7 = _slicedToArray(_e, 2),
          t = _e7[0],
          n = _e7[1];
        if (n = Array.isArray(n) ? n : [n], !function (e, t, n) {
          var s = function (r, e) {
            var _e$version;
            if ("swup" === r) return (_e$version = e.version) !== null && _e$version !== void 0 ? _e$version : "";
            {
              var _t$version;
              var _t = e.findPlugin(r);
              return (_t$version = _t === null || _t === void 0 ? void 0 : _t.version) !== null && _t$version !== void 0 ? _t$version : "";
            }
          }(e, n);
          return !!s && function (e, t) {
            return t.every(function (t) {
              var _ref = t.match(/^([\D]+)?(.*)$/) || [],
                _ref2 = _slicedToArray(_ref, 3),
                n = _ref2[1],
                s = _ref2[2];
              var o, i;
              return function (r, e) {
                var t = {
                  "": function _(r) {
                    return 0 === r;
                  },
                  ">": function _(r) {
                    return r > 0;
                  },
                  ">=": function _(r) {
                    return r >= 0;
                  },
                  "<": function _(r) {
                    return r < 0;
                  },
                  "<=": function _(r) {
                    return r <= 0;
                  }
                };
                return (t[e] || t[""])(r);
              }((i = s, o = r(o = e), i = r(i), o.localeCompare(i, void 0, {
                numeric: !0
              })), n || ">=");
            });
          }(s, t);
        }(t, n, _this.swup)) {
          var _r2 = "".concat(t, " ").concat(n.join(", "));
          throw new Error("Plugin version mismatch: ".concat(_this.name, " requires ").concat(_r2));
        }
      }), !0;
    }
  }, {
    key: "on",
    value: function on(r, _e2, t) {
      var n;
      void 0 === t && (t = {}), _e2 = !(n = _e2).name.startsWith("bound ") || n.hasOwnProperty("prototype") ? _e2.bind(this) : _e2;
      var s = this.swup.hooks.on(r, _e2, t);
      return this.handlersToUnregister.push(s), s;
    }
  }, {
    key: "once",
    value: function once(r, _e3, t) {
      return void 0 === t && (t = {}), this.on(r, _e3, _objectSpread(_objectSpread({}, t), {}, {
        once: !0
      }));
    }
  }, {
    key: "before",
    value: function before(r, _e4, t) {
      return void 0 === t && (t = {}), this.on(r, _e4, _objectSpread(_objectSpread({}, t), {}, {
        before: !0
      }));
    }
  }, {
    key: "replace",
    value: function replace(r, _e5, t) {
      return void 0 === t && (t = {}), this.on(r, _e5, _objectSpread(_objectSpread({}, t), {}, {
        replace: !0
      }));
    }
  }, {
    key: "off",
    value: function off(r, _e6) {
      return this.swup.hooks.off(r, _e6);
    }
  }]);
  return e;
}();
export { e as default };